import { createAction, props } from '@ngrx/store';

export const setShowWholesalePrices = createAction(
  '[User] Set show wholesale prices',
  props<{ show: boolean }>(),
);

export const setDarkMode = createAction(
  '[User] Set Dark mode',
  props<{ darkModeOn: boolean }>(),
);

export const setPreventZoom = createAction(
  '[User] Set Prevent Zoom',
  props<{ preventZoom: boolean }>(),
);

export const setAdvancedMDOMode = createAction(
  '[User] Set advanced MDO mode',
  props<{ advancedMDOMode: boolean }>(),
);

export const setSubscribeToAllEmails = createAction(
  '[User] Set subscribe to all emails',
  props<{ isSubscribedToAccountBaskets: boolean }>(),
);

export const setSubscribeToAllEmailsSuccess = createAction(
  '[User] Set subscribe to all emails Success',
  props<{ isSubscribedToAccountBaskets: boolean }>(),
);

export const setFirstLoginAction = createAction(
  '[User] Set first login action',
);
